import React, { useEffect, useState } from 'react';
import FormEdit from './pages/FormEdit';
import PIRTPersyaratan from './pages/PIRTPersyaratan';
import FormSuccess from './pages/FormSuccess';
import Container from 'view/portal/pages/services-page/modules/Container';
import ProgressBar from 'view/portal/pages/services-page/pages/pirt-page/ProgressBar';
// import FormPemohon from './pages/FormPemohon';
import FormPersyaratanPenyuluhan from './pages/FormPersyaratanPenyuluhan';
// import FormJadwal from './pages/FormJadwal';
// import FormDaftarPenyuluhan from './pages/FormDaftarPenyuluhan';
import FormPemohon from '../components/FormPemohon';
import FormJadwal from '../components/FormJadwal';

const DaftarPenyuluhan = () => {
  const [step, setStep] = useState(1);
  const [data, setData] = useState({});
  const [isProgressHidden, setIsProgressHidden] = useState(false);
  const formName = [
    'Pendaftaran',
    'Persyaratan',
    'Selesai',
  ];
  const components = [
    FormPemohon,
    // FormDaftarPenyuluhan,
    FormPersyaratanPenyuluhan,
    FormSuccess,
    FormEdit,
  ];
  const nextStep = () => setStep((prevStep) => prevStep + 1);

  const renderComponent = (thisIndex) =>
    components.map((Component, i) => {
      return (
        <Component
          type='penyuluhan'
          index={{ in: i, thisIndex }}
          key={i}
          {...data}
          setIsProgressHidden={setIsProgressHidden}
          nextStep={nextStep}
          setStep={setStep}
          setData={setData}
          isShow={i + 1 === thisIndex ? true : false}
        />
      );
    });

  const totalStep = formName.length;

  return (
    <>
      <ProgressBar
        isProgressHidden={isProgressHidden}
        progress={Math.floor(((step - 1) / (totalStep - 1)) * 100)}
        formName={formName}
        nowStep={step <= totalStep ? step : 1}
        changeStep={setStep}
      />
      <Container full>{renderComponent(step)}</Container>
    </>
  );
};

export default DaftarPenyuluhan;
